import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { getDefaultClass, listClasses, readableApiError, formatClassSubtitle } from '../../api/dashboard';
import { useAuth } from '../../context/AuthContext';
import './dashboard.css';

export default function ClassListPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [resolvingDefault, setResolvingDefault] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const enterpriseId = searchParams.get('enterprise');

  // class-stream 多班级修复:enterprise_admin 改为渲染班级列表(看/切本企业全部班),
  // 不再强制跳"默认班"——多班企业下直跳第一个班会把管理员锁死在单个班,看不到也
  // 切不了其他班(用户实测反馈)。仅讲师保留单班直跳(通常授课单班,getDefaultClass
  // 返回其授课首班)。admin / superadmin 本就渲染列表(跨企业)。
  useEffect(() => {
    const role = user?.role;
    if (role !== 'instructor') {
      setResolvingDefault(false);
      return;
    }
    let cancelled = false;
    getDefaultClass()
      .then((d) => {
        if (cancelled) return;
        const id = d?.class?.id;
        if (id != null) {
          navigate(`/dashboard/classes/${id}`, { replace: true });
        } else {
          setResolvingDefault(false);
        }
      })
      .catch(() => {
        if (cancelled) return;
        // 默认班解析失败(404 / 网络) → 退回选择器
        setResolvingDefault(false);
      });
    return () => { cancelled = true; };
  }, [user?.role, navigate]);

  useEffect(() => {
    if (resolvingDefault) return;
    const params = { is_active: true };
    if (enterpriseId) params.enterprise = enterpriseId;
    listClasses(params)
      .then(setData)
      .catch((err) => setError(readableApiError(err, '加载班级列表失败')));
  }, [resolvingDefault, enterpriseId]);

  if (resolvingDefault) {
    return (
      <div className="aiq-dash dash-page">
        <div className="dash-card">正在打开看板...</div>
      </div>
    );
  }

  return (
    <div className="aiq-dash dash-page">
      {enterpriseId && (
        <>
          <Link to="/dashboard/enterprises" className="dash-back">← 返回企业列表</Link>
          <div className="dash-sub" style={{ marginTop: 4 }}>
            {location.state?.enterpriseName
              || data?.results?.[0]?.enterprise?.name
              || '企业班级'}
          </div>
        </>
      )}
      <div className="dash-head">
        <h1 className="dash-h1">班级列表</h1>
        <p className="dash-sub">讲师看自己授课的班级；企业管理员看本企业全部班级。</p>
      </div>

      {error && <div className="dash-card dash-card--error">{error}</div>}
      {!data && !error && <div className="dash-card">加载中...</div>}
      {data && data.results.length === 0 && (
        <div className="dash-card">
          <div style={{ fontWeight: 600, marginBottom: 6 }}>暂无班级</div>
          <div className="dash-mut">当你被分配为讲师或企业管理员后，该班级会出现在这里。</div>
        </div>
      )}
      {data && data.results.length > 0 && (
        <>
          <p className="dash-mut">
            共 {data.count ?? data.results.length} 个班级
            {/* TODO M22: 后端配 pagination_class 后接入翻页（list envelope 已就位） */}
          </p>
          <div className="dash-list">
            {data.results.map((cls) => (
              <Link key={cls.id} to={`/dashboard/classes/${cls.id}`} className="dash-list-card">
                <div>
                  <div className="dash-list-card__name">{cls.name}</div>
                  <div className="dash-mut">{formatClassSubtitle(cls)}</div>
                </div>
                <div>
                  <div className="dash-list-card__stat">
                    {cls.completed_count} / {cls.member_count}
                  </div>
                  <div className="dash-mut" style={{ textAlign: 'right' }}>已完成 / 总人数</div>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
